import React from 'react';
import PrimaryButton from '../../components/PrimaryButton';

function Start({ history }) {
    return (
        <div className='modal'>
            <div className='modal__content'>
                <div className='modal__title'>
                    <h2>Digitale Unterzeichnung des Kreditvertrags</h2>
                </div>
                <div className='modal__body'>
                    <p>Ihr Kreditantrag liegt zur Unterzeichnung bereit. Bitte überprüfen Sie zunächst die untenstehenden Rahmendaten des Kredits.</p>
                </div>
                <div className='credit'>
                    <ul className='credit__additional'>
                        <li>Laufzeit: 84 Monate</li>
                        <li>Freie Verwendung</li>
                        <li>Sofortauszahlung</li>
                    </ul>
                    <dl className='credit__sum'>
                        <dt>Kredithöhe:</dt>
                        <dd>20.000€</dd>
                        <dt>Kreditzins:</dt>
                        <dd>3,39% <small>p.a. eff.</small></dd>
                        <dt>mtl. Gesamtrate:</dt>
                        <dd>268,00€</dd>
                    </dl>
                </div>
                <div class='modal__footer'>
                    <PrimaryButton
                        title='Jetzt digital unterzeichnen'
                        onClick={() => history.push('/dashboard/certificate')}
                    />
                </div>
            </div>
        </div>
    )
}

export default Start;
